export default function SvgCompass({angle}) {
    return (
        <svg
              style={{
                width: '1.5rem', // w-6
                height: '1.5rem', // h-6
                color: '#4b5563', // text-gray-600
                transition: 'transform 300ms ease-out', // transition-transform duration-300 ease-out
                transform: `rotate(${angle}deg)`,
              }}
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10 18a.75.75 0 01-.75-.75V4.66L7.18 7.32a.75.75 0 11-1.06-1.06l3.25-3.25a.75.75 0 011.06 0l3.25 3.25a.75.75 0 11-1.06 1.06L10.75 4.66v12.59c0 .414-.336.75-.75.75z"
                clipRule="evenodd"
              />
            </svg>
    )
}